import React from 'react';
import { Breadcrumb } from 'gatsby-plugin-breadcrumb';
import PropTypes from 'prop-types';
import hiddenItems from './hiddenItems';
import './breadcrumb.css';

class BreadcrumbWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    onItemClick = (event) => {
        if (event.target.parentNode.parentNode.children.item(0) !== event.currentTarget.parentNode) {
            event.preventDefault();
        }
    };

    render() {
        const { pageTitle, crumbs } = this.props;

        if (crumbs.length <= 1) {
            return <></>;
        }

        if (crumbs[0].crumbLabel === 'Root') {
            crumbs.shift();
        }
        const lastItem = crumbs[crumbs.length - 1];

        if (crumbs.length <= 1) {
            return <></>;
        }

        if (lastItem && lastItem.pathname) {
            crumbs.pop();
            crumbs.push({ crumbLabel: pageTitle });
        }

        return (
            <>
                <Breadcrumb
                    onClick={this.onItemClick}
                    hiddenCrumbs={hiddenItems}
                    crumb={crumbs}
                    {...this.props}
                ></Breadcrumb>
            </>
        );
    }
}

BreadcrumbWrapper.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    crumbs: PropTypes.array.isRequired,
};

export default BreadcrumbWrapper;
